import { AxiosResponse } from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { GET_COMPANY_NAME } from "../gql/companies";
import { request } from "../helpers/utilities";
import "../styles/components/CustomerPageTitle.css";

type FetchState = {
  loading: boolean;
  error: boolean;
  data: {
    name: string | null;
  };
};

export default function CompanyPageTitle(): JSX.Element {
  const location = useLocation();
  const [fetchState, setFetchState] = useState<FetchState>({
    loading: false,
    error: false,
    data: {
      name: null,
    },
  });

  const companyId = useCallback(() => {
    const match = location.pathname.match(/^\/companies\/([^/]+)$/);
    return match ? match[1] : null;
  }, [location.pathname]);

  const fetchCompanyName = useCallback(async () => {
    const id = companyId();
    if (!id) return;

    setFetchState((prev) => ({ ...prev, loading: true, error: false }));

    try {
      const response: AxiosResponse = await request({
        query: GET_COMPANY_NAME,
        variables: { companyId: id },
      });

      const companyData = response.data?.data?.company;

      if (companyData?.name) {
        setFetchState({
          loading: false,
          error: false,
          data: {
            name: companyData.name,
          },
        });
      } else {
        setFetchState({
          loading: false,
          error: true,
          data: { name: null,  },
        });
      }
    } catch (error) {
      setFetchState({
        loading: false,
        error: true,
        data: { name: null, },
      });
    }
  }, [companyId]);

  useEffect(() => {
    fetchCompanyName();
  }, [fetchCompanyName]);


  if (fetchState.error) {
    return (
      <span className="customer-title error">
        <button
          className="retry-button"
          onClick={(e) => {
            e.preventDefault();
            fetchCompanyName();
          }}
          aria-label="Retry loading company name"
        >
          Retry
        </button>
      </span>
    );
  }

  return (
    <span className="customer-title">
      {fetchState.loading ? (
        "Loading..."
      ) : (
        <>
          {fetchState.data.name}
        </>
      )}
    </span>
  );
}
